export const DEFAULT_ACCORDION_STYLE = {
  fontSize: 14,
  fontWeight: 400,
  height: 56,
} as const;
